import React, { useState } from 'react';

import { useServerVersion } from '@portal/utils';

interface VersionInfoProps {
  version?: string;
}

export const VersionInfoUI = ({ version = '1.0.0' }: VersionInfoProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const serverVersionQuery = useServerVersion();

  return (
    <div className='fixed top-4 right-4 z-40'>
      <div
        className='bg-black/20 backdrop-blur-sm rounded-lg px-2 py-1 text-xs text-white/80 font-mono cursor-pointer hover:bg-black/30 transition-all duration-200'
        onClick={() => setIsExpanded(!isExpanded)}
        title='Click to see more info'
      >
        <div className='flex items-center'>
          {isExpanded ? <>Portal: v{version}</> : <>v{version}</>}
          {isExpanded && (
            <div className='text-white/60'>
              {serverVersionQuery.data?.body?.version && (
                <span className='ml-1'> • Server: v{serverVersionQuery.data.body.version}</span>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
